/**
 *  [2021] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * reproduction of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */

/**
 * :ZNOTE:
 * tag: logger
 * note:
 *  - ログレベルに合わせて出力スタイルを変更する
 * sample:
 *  -
 * :ZNOTE:
 */

const Logging = (process.env.NODE_ENV === 'development')
  ? {
    error: console.info.bind(console, '%c%s', 'color:red;font-weight:bold;'),
    warn: console.info.bind(console, '%c%s', 'color:orange;font-weight:bold;'),
    info: console.info.bind(console, '%c%s', 'color:blue'),
    log: console.log.bind(console, '%c%s', ''),
    debug: console.debug.bind(console, '%c%s', '')
  }
  : {
    error: console.info.bind(console, '%c%s', 'color:red;font-weight:bold;'),
    warn: console.info.bind(console, '%c%s', 'color:orange;font-weight:bold;'),
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    info: () => {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    log: () => {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    debug: () => {}
  };

export default Logging;
export {Logging};
